<template>
  <!-- organization template about add and edit department -->
  <div class="org-wrap">
    <div class="com-Breadcrumb" v-if="!hideBlackTitle">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item
          ><router-link class="item" to="/console/member">成员管理</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>调整组织架构</el-breadcrumb-item>
      </el-breadcrumb>
      <a class="r-btn" @click="$router.push({ path: '/console/member' })"
        >返回上一步</a
      >
    </div>
    <div class="table-style">
      <div class="title-lab">
        <h1 class="com-title com-ht">
          <i></i>调整组织架构<span class="ms"
            >/
            为企业添加下级组织架构（如分公司、部门等），为各个部门设置主管，部门主管作为按职级审批时的默认审批人。</span
          >
        </h1>
        <p v-if="isAdmin">
          <el-button
            type="primary"
            size="small"
            @click="synchronous"
            style="margin-right: 10px"
            >同步组织架构</el-button
          >
          <el-tooltip
            effect="dark"
            content="若当前账号已在君子签SaaS中使用并有成员加入，受钉钉限制，同步后成员的部门信息需重新设置"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </p>
      </div>
      <div style="padding: 20px">
        <table class="el-table">
          <thead>
            <tr
              style="
                background: #f9f9f9;
                color: #333333;
                fontweight: 600;
                text-align: left;
              "
            >
              <th>组织名称</th>
              <th>人数</th>
              <th>部门主管</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody ref="referenceTBody">
            <tr v-if="treeGroup.length === 0">
              <td colspan="3" style="text-align: center; color: red">
                {{ "暂无数据-" + errorDescription }}
              </td>
            </tr>
            <tr
              :trindexid="'trindexid' + index + v.corpGroupId"
              :level="0"
              v-for="(v, index) in treeGroup"
              :key="index"
              style="line-height: 45px; border-bottom: 1px solid #ebeef5"
            >
              <td>
                <span
                  v-if="v.childCorpGroups"
                  @click="expandFirstClick(v, index)"
                  class="expand-icon-style"
                >
                  <i v-if="!v.expand" class="el-icon-circle-plus"></i>
                  <i v-if="v.expand" class="el-icon-remove"></i>
                </span>
                {{ v.groupName }}
              </td>
              <td>{{ v.totalNum }}</td>
              <td>{{ v.corpGroupManName || "~~~" }}</td>
              <td>
                <div class="custom-btn" v-if="v.editFlag === 1">
                  <a
                    href="javascript:void(0);"
                    @click="handleClickAddChild(v)"
                    style="margin-right: 10px"
                    >添加下级</a
                  >
                  <a
                    href="javascript:void(0);"
                    @click="handleClickSetManager(v)"
                    >设置主管</a
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- dialog add or edit organization -->
    <el-dialog
      :title="visibleDialogTitle"
      :visible.sync="visibleDialog"
      width="40%"
    >
      <el-form
        ref="formDept"
        :rules="formDeptRules"
        label-position="right"
        label-width="80px"
        :model="modelDialog"
      >
        <el-form-item label="上级部门">
          <!-- 添加 -->
          <el-select
            v-if="!isEdit"
            size="mini"
            v-model="modelDialog.parentId"
            placeholder="请选择"
            style="width: 220px"
          >
            <el-option
              :label="modelDialog.parentDeptName"
              :value="modelDialog.parentId"
            ></el-option>
          </el-select>
          <!-- 编辑 -->
          <el-tree
            v-if="isEdit"
            ref="tree"
            style="max-height: 400px; overflow-y: auto"
            :data="superDeptsTree"
            @check="handleCheck"
            show-checkbox
            :check-strictly="true"
            :highlight-current="true"
            :expand-on-click-node="false"
            node-key="corpGroupId"
            :default-expand-all="true"
            :props="defaultProps"
          >
            <div
              slot-scope="{ node, data }"
              style="width: 100%"
              :title="data.groupName"
            >
              <p
                class="name"
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  max-width: 100%;
                  padding-right: 50px;
                "
              >
                {{ data.groupName }}
              </p>
            </div>
          </el-tree>
        </el-form-item>
        <el-form-item label="部门名称" prop="departmentName">
          <el-input
            size="mini"
            v-model="modelDialog.departmentName"
            placeholder="请输入部门名称"
            style="width: 220px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          @click="(visibleDialog = false), (deptSaasVisi = false)"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="handleClickAddEdit()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- dialog set manager -->
    <el-dialog
      title="设置主管"
      :visible.sync="visibleDialogSetManager"
      width="800px"
    >
      <el-row :gutter="20">
        <el-col
          :span="24"
          style="margin-top: -15px; padding-right: 0; text-align: end"
        >
          <el-form :inline="true" :model="setManagerFilters" size="small">
            <el-form-item>
              <el-input
                v-model="setManagerFilters.keyword"
                placeholder="姓名/企业名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleClickSearchManager">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- table -->
        <el-col :span="24" style="margin-top: -15px" class="custom-table-style">
          <el-table
            :data="tableSetManager"
            style="border: 1px solid #cbcbcb; border-bottom: 0"
            tooltip-effect="dark"
            @row-click="handleClickRow"
            highlight-current-row
            :header-cell-style="{
              background: '#f9f9f9',
              color: '#333333',
              fontWeight: '600',
            }"
          >
            <el-table-column label="姓名/企业名称" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.userName }}
                <span v-if="scope.row.targetId != ''">{{
                  `(${scope.row.targetId})`
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="部门"
              prop="groupNames"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </el-col>
        <!-- pagination -->
        <el-col :span="24" style="padding: 30px 0; position: relative" class="page-flex-end">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="setManagerFilters.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="setManagerFilters.pageSize"
            layout="sizes, prev, pager, next, total"
            :total="setManagerFilters.pageTotal"
          />
          <el-go
            :page-size="setManagerFilters.pageSize"
            :total="setManagerFilters.pageTotal"
            @current-change="handleCurrentChange"
          ></el-go>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleDialogSetManager = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="handleClickSetManagerOk()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 钉钉环境同步组织架构 -->
    <el-dialog title="同步组织架构" :visible.sync="synchVisi" width="40%">
      <div class="dia-sync-sty">
        <!-- 钉钉待同步部门 -->
        <div>
          <h1>当前钉钉的组织架构</h1>
          <!-- <p>公司名称</p> -->
          <!-- 部门树结构 -->
          <div class="tree-sty">
            <el-tree
              empty-text="暂无数据"
              :data="dingTreeData"
              :props="dingTreeProp"
              node-key="deptId"
              default-expand-all
              highlight-current
              :check-on-click-node="true"
              :expand-on-click-node="false"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button type="text" size="mini" @click="association(data)">
                    {{
                      treeGroupList.includes(data.deptId.toString())
                        ? "修改"
                        : "关联"
                    }}
                  </el-button>
                  <el-button
                    v-show="treeGroupList.includes(data.deptId.toString())"
                    type="text"
                    size="mini"
                    @click="assetsHandle(data)"
                  >
                    取消关联
                  </el-button>
                </span>
              </span>
            </el-tree>
          </div>
          <div>
            <el-button @click="synchVisi = false" size="mini">取 消</el-button>
            <el-button
              slot="reference"
              type="primary"
              :loading="syncConfirmLoading"
              @click="saasSyncHandle"
              size="mini"
              >确认同步</el-button
            >
          </div>
        </div>
        <!-- 要关联的部门 -->
        <div v-show="deptSaasVisi">
          <h1>请选择与哪个部门关联（当前君子签组织架构）</h1>
          <!-- <p>公司名称</p> -->
          <!-- 部门树结构 -->
          <div class="tree-sty">
            <el-tree
              ref="assTreeRef"
              empty-text="暂无数据"
              :data="saasDeft"
              :props="GroupProp"
              node-key="corpGroupId"
              default-expand-all
              highlight-current
              :check-on-click-node="true"
              :expand-on-click-node="false"
            >
              <!-- <el-radio-group v-model="checkRadio"> -->
              <!-- <span class="custom-tree-node" slot-scope="{ node, data }"> -->
              <el-radio
                v-model="checkRadio"
                :label="data.corpGroupId"
                :disabled="
                  !['', null, 'null', undefined, 'undefined'].includes(
                    data.thirdGroupId
                  )
                "
                slot-scope="{ node, data }"
                >{{ node.label }}</el-radio
              >
              <!-- </span> -->
              <!-- </el-radio-group> -->
            </el-tree>
          </div>
          <div>
            <el-button
              type="primary"
              :loading="assetsLoading"
              @click="assetsHandle()"
              size="mini"
              >关 联</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import ElGo from "../../components/go/Go";
export default {
  name: "organization",
  components: { ElGo },
  props: {
    hideBlackTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInDingTalk,
      // 同步组织架构 start
      synchVisi: false,
      // 钉钉组织树
      dingTreeData: [],
      dingTreeProp: { label: 'deptName', children: 'subDeptList' },
      treeGroupList: [], // 存放已经关联的数据
      GroupProp: { label: 'groupName', children: 'childCorpGroups' },
      checkRadio: '', // 选中要关联的数据
      syncConfirmLoading: false,
      assetsLoading: false,
      currentDept: {}, // 点击关联/修改的item（被关联方）
      deptSaasVisi: false, // 关联卡片
      // saas组织树
      // 同步组织架构 end
      isEdit: false,
      selectNodeDeptId: undefined,
      superDeptsTree: [],
      superDeptsTreeCopy: [],
      defaultProps: {
        children: "childCorpGroups",
        label: "groupName"
      },
      superDepts: {},
      // module --- set manager
      visibleDialogSetManager: false,
      setManagerFilters: {
        keyword: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      },
      tableSetManager: [],
      selectCorpGroupId: undefined, // select group id
      selectCorpUserId: undefined, // select user id
      treeGroup: [],
      errorDescription: "",
      orgMap: {},
      visibleDialog: false,
      visibleDialogTitle: "",
      modelDialog: {
        parentId: "",
        parentDeptName: "",
        departmentId: "",
        departmentName: ""
      },
      formDeptRules: {
        departmentName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ]
      }
    };
  },
  mounted () {
    this.initTreeGroup();
    // 钉钉环境获取钉钉部门数据
    if (isInDingTalk) this.getDingDeptTree()
  },
  methods: {
    /** 关联 */
    assetsHandle (data) {
      if (!this.checkRadio && !data) return this.$message.error('请选择要关联的部门数据')
      this.assetsLoading = true
      const { dingTalkCorpId: corpId } = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const params = {
        relations: [{ corpGroupId: this.checkRadio, dingTalkDeptId: data ? data.deptId : this.currentDept.deptId.toString() }],
        // corpId
      }
      ApiCorpMethods.dingTalkGroupBind(params).then(res => {
        if (!res.success) return this.$message.error(res.description)
        this.initTreeGroup()
        this.currentDept = {}
        this.checkRadio = ''
        this.treeGroupList = []
        this.$message.success(res.description)
      }).finally(() => { this.deptSaasVisi = false, this.assetsLoading = false })
    },
    /** 同步SaaS部门数据 */
    saasSyncHandle () {
      const _this = this;
      _this.$confirm(`
      <p>是否确认同步组织架构？</p>
				<p style="color:#ec1c1c">同步后钉钉组织架构将覆盖当前组织架构</p>
			`, '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        _this.syncConfirm()
      }).catch(() => { })
    },
    /** 同步saas部门数据 */
    syncConfirm () {
      const _this = this;
      _this.syncConfirmLoading = true
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.saasSync(param).then(res => {
        if (!res.success) _this.$message.error(res.description)
        _this.$message.success(res.description)
        this.currentDept = {}
        this.checkRadio = ''
        _this.synchVisi = false
      }).finally(() => { _this.syncConfirmLoading = false })
    },
    /** 过滤出已经关联的数据 */
    filterComp (tree) {
      tree.map(item => {
        if (Array.isArray(item.childCorpGroups)) this.filterComp(item.childCorpGroups)
        if (item.thirdGroupId) this.treeGroupList.push(item.thirdGroupId)
      })
    },
    /** 打开关联组织架构弹窗 */
    association (data) {
      this.currentDept = data
      this.deptSaasVisi = true
    },
    /** 同步组织架构 */
    synchronous () {
      // 1. 如果只有一层组织架构
      // 2. 如果有多层组织架构
      const outline = this.treeGroup[0]
      outline && outline.childCorpGroups ? this.synchVisi = true : this.syncConfirm
    },
    // convert data for tree formate
    // 转换成tree需要的数据格式
    convertFormateTree (data) {
      data.forEach(element => {
        element.expand = false;
        element.loaded = false;
        this.orgMap[element.corpGroupId] = element;
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    getDingDeptTree () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo")), _this = this;
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.deptList(param).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.dingTreeData = res.data.subDeptList
      })
    },
    recursionChildren (children) {
      children.forEach(element => {
        element.expand = false;
        element.loaded = false;
        this.orgMap[element.corpGroupId] = element;
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    // init org staructure data
    // 初始化组织机构数据
    initTreeGroup () {
      let params = {};
      params.permId = 7;
      params.loadGroupMan = 1;
      // ApiCorpMethods.OrganizationController.treeGroup(params)
      ApiCorpMethods.OrganizationController.topGroup(params)
        .then(res => {
          if (res.code === "0") {
            if (this.$refs.referenceTBody) {
              const trs = this.$refs.referenceTBody.querySelectorAll(
                "[auto-tr]"
              );
              Array.prototype.slice.call(trs).forEach(element => {
                this.$refs.referenceTBody.removeChild(element);
              });
            }
            this.treeGroup = [];
            this.treeGroup = this.convertFormateTree(res.data);
            if (isInDingTalk) this.filterComp(res.data)
            this.$nextTick(() => {
              for (let index = 0; index < this.treeGroup.length; index++) {
                const element = this.treeGroup[index];
                this.expandFirstClick(element, index);
                if (element.childCorpGroups) {
                  this.defaultExpendChild(element.childCorpGroups);
                }
              }
            });
          } else {
            this.$message.error(res.description);
            this.errorDescription = res.description;
          }
        })
        .catch(error => {
          console.info(error);
          this.$message.error(error.description || "数据加载错误");
        });
    },

    // default expend child
    defaultExpendChild (childCorpGroups) {
      childCorpGroups.forEach((v, index) => {
        v.expand = true;
        let currentTr = document.querySelectorAll(
          'tr[trindexid = "trindexid' + index + v.corpGroupId + '"]'
        );
        if (currentTr) {
          currentTr = currentTr[0];
        }
        v.loaded = true;
        currentTr && this.autoGenerateChild(v, index, currentTr);
        if (v.childCorpGroups) {
          this.defaultExpendChild(v.childCorpGroups);
        }
      });
    },

    // expand event
    expandFirstClick (v, index) {
      v.expand = !v.expand;
      let currentTr = document.querySelectorAll(
        'tr[trindexid = "trindexid' + index + v.corpGroupId + '"]'
      );
      if (currentTr) {
        currentTr = currentTr[0];
      }
      if (!v.loaded) {
        v.loaded = true;
        currentTr && this.autoGenerateChild(v, index, currentTr);
      } else {
        this.expandAll(v, index);
      }
    },
    expandClick (v, index, currentTr) {
      v.expand = !v.expand;
      const vvvi = currentTr.querySelectorAll(".expand-icon-style > i")[0];
      vvvi.classList.remove("el-icon-circle-plus", "el-icon-remove");
      const icon = v.expand ? "el-icon-remove" : "el-icon-circle-plus";
      vvvi.classList.add(icon);
      if (!v.loaded) {
        v.loaded = true;
        currentTr && this.autoGenerateChild(v, index, currentTr);
      } else {
        this.expandAll(v, index);
      }
    },
    // expandAll
    expandAll (v, index) {
      // 一层
      const childTr = document.querySelectorAll(
        'tr[trchildindexid = "trchildindexid' + index + v.corpGroupId + '"]'
      );
      childTr.forEach((element, i) => {
        if (v.expand) {
          element.style.display = "";
        } else {
          element.style.display = "table-column";
          // has children
          const vvvi = element.querySelectorAll(".expand-icon-style > i");
          if (vvvi && vvvi.length) {
            // change icon
            vvvi[0].classList.remove("el-icon-circle-plus", "el-icon-remove");
            vvvi[0].classList.add("el-icon-circle-plus");
          }
        }
      });
      if (v.childCorpGroups && v.expand === false) {
        this.recursionChildrenClose(v);
      }
    },
    recursionChildrenClose (v) {
      // 2层+
      v.childCorpGroups.forEach((elementLv1, index) => {
        elementLv1.expand = false;
        const childTr = document.querySelectorAll(
          'tr[trchildindexid = "trchildindexid' +
          index +
          elementLv1.corpGroupId +
          '"]'
        );
        // get icon
        childTr.forEach((element, i) => {
          console.log("element", element);
          element.style.display = "table-column";
          // has children
          const vvvi = element.querySelectorAll(".expand-icon-style > i");
          if (vvvi && vvvi.length) {
            // change icon
            vvvi[0].classList.remove("el-icon-circle-plus", "el-icon-remove");
            vvvi[0].classList.add("el-icon-circle-plus");
          }
        });
        if (elementLv1.childCorpGroups) {
          this.recursionChildrenClose(elementLv1);
        }
      });
    },
    // insert children nodes
    autoGenerateChild (v, index, currentTr) {
      const doc = document.createDocumentFragment();
      if (!v.childCorpGroups) return;
      v.childCorpGroups.forEach((element, elementIndex) => {
        // create `tr`
        const tr = document.createElement("tr");
        tr.style.lineHeight = "35px";
        tr.style.borderBottom = "1px solid #ebeef5";
        tr.setAttribute("auto-tr", true);
        tr.setAttribute(
          "trindexid",
          "trindexid" + elementIndex + element.corpGroupId
        );
        tr.setAttribute(
          "trchildindexid",
          "trchildindexid" + index + v.corpGroupId
        );
        let levelIndex =
          currentTr && currentTr.getAttribute("level")
            ? currentTr.getAttribute("level")
            : 0;
        levelIndex = parseInt(levelIndex);
        levelIndex++;
        tr.setAttribute("level", levelIndex);
        const td_name = document.createElement("td");
        const td_count = document.createElement("td");
        const td_manager = document.createElement("td");
        const td_operate = document.createElement("td");
        // name
        const span_expand = document.createElement("span");
        span_expand.classList.add("expand-icon-style");
        span_expand.style.marginLeft = 30 * levelIndex + "px";
        if (element.childCorpGroups) {
          const vi = document.createElement("i");
          if (v.expand) {
            vi.classList.add("el-icon-remove");
          } else {
            vi.classList.add("el-icon-circle-plus");
          }
          span_expand.appendChild(vi);
          // add click event
          vi.onclick = () => {
            this.expandClick(element, elementIndex, tr);
          };
        }
        td_name.appendChild(span_expand);
        td_name.appendChild(document.createTextNode(element.groupName));
        // count
        td_count.innerHTML = element.totalNum;
        // manager
        let managerLabel = "~~~";
        if (element.corpGroupManName) {
          managerLabel =
            element.corpGroupManName + "(" + element.corpGroupManTargetId + ")";
        }
        td_manager.innerHTML = managerLabel;
        // operate
        const div_operate = document.createElement("div");
        div_operate.classList.add("custom-btn");
        const a_template = document.createElement("a");
        a_template.href = "javascript:void(0);";
        const a_add = a_template.cloneNode(false);
        a_add.innerHTML = "添加下级";
        a_add.onclick = () => {
          this.handleClickAddChild(element);
        };
        a_add.style.display = element.editFlag === 1 ? "inline-block" : "none";
        const a_edit = a_template.cloneNode(false);
        a_edit.innerHTML = "编辑";
        a_edit.onclick = () => {
          this.handleClickEditSelf(element);
        };
        a_edit.style.display = element.editFlag === 1 ? "inline-block" : "none";
        const a_delete = a_template.cloneNode(false);
        a_delete.innerHTML = "删除";
        a_delete.onclick = () => {
          this.handleClickDeleteSelf(element);
        };
        a_delete.style.display =
          element.editFlag === 1 ? "inline-block" : "none";
        const a_set_manager = a_template.cloneNode(false);
        a_set_manager.innerHTML = "设置主管";
        a_set_manager.onclick = () => {
          this.handleClickSetManager(element);
        };
        a_set_manager.style.display =
          element.editFlag === 1 ? "inline-block" : "none";
        const strong_template = document.createElement("strong");
        strong_template.innerHTML = "";
        div_operate.appendChild(a_add);
        div_operate.appendChild(strong_template.cloneNode(true));
        div_operate.appendChild(a_edit);
        div_operate.appendChild(strong_template.cloneNode(true));
        div_operate.appendChild(a_delete);
        div_operate.appendChild(strong_template.cloneNode(true));
        div_operate.appendChild(a_set_manager);
        td_operate.appendChild(div_operate);

        tr.appendChild(td_name);
        tr.appendChild(td_count);
        tr.appendChild(td_manager);
        tr.appendChild(td_operate);
        doc.appendChild(tr);
      });
      // find next brother
      const next = this.findNextBrother(currentTr);
      if (next) {
        currentTr.parentNode.insertBefore(doc, next);
      } else {
        currentTr.parentNode.appendChild(doc);
      }
    },
    findNextBrother (currentTr) {
      let next = undefined;
      const children = currentTr.parentNode.children;
      for (let index = 0; index < children.length; index++) {
        const element = children[index];
        if (element === currentTr) {
          if (children[index + 1]) {
            next = children[index + 1];
          }
          break;
        }
      }
      return next;
    },
    // handle click event of set manager
    handleClickSetManager (v) {
      this.visibleDialogSetManager = true;
      this.selectCorpGroupId = v.corpGroupId;
      this.queryTool();
    },
    handleClickSetManagerOk () {
      if (this.selectCorpUserId === undefined) {
        this.$message.error("请选择要设置的主管");
        return;
      }
      let params = {};
      params.corpUserId = this.selectCorpUserId;
      params.corpGroupId = this.selectCorpGroupId;
      ApiCorpMethods.OrganizationController.setGroupMan(params)
        .then(res => {
          if (res.success) {
            this.visibleDialogSetManager = false;
            this.initTreeGroup();
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // handle click event of add child
    handleClickAddChild (self) {
      if (this.$refs["formDept"]) {
        this.$refs["formDept"].resetFields();
      }
      this.isEdit = false;
      // init parent dept
      const parentDept = this.orgMap[self.corpGroupId];
      this.modelDialog.parentId = self.corpGroupId;
      this.modelDialog.parentDeptName = parentDept.groupName;
      this.modelDialog.departmentName = "";
      this.modelDialog.departmentId = "";
      this.openDialog(false);
    },
    // handle click event of edit self
    handleClickEditSelf (self) {
      this.getSuperDepartment(self);
      if (this.$refs["formDept"]) {
        this.$refs["formDept"].resetFields();
      }
      this.isEdit = true;
      // init parent dept
      const parentDept = this.orgMap[self.parentId];
      this.modelDialog.parentId = self.parentId;
      this.modelDialog.parentDeptName = parentDept.groupName;
      this.modelDialog.departmentName = self.groupName;
      this.modelDialog.departmentId = self.corpGroupId;
      this.openDialog(true);
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.selectNodeDeptId = self.parentId;
          this.$refs.tree.setChecked(parentDept, true);
        }
      });
    },
    // handle click event of delete self
    handleClickDeleteSelf (self) {
      this.handleClickDeleteSelfMessageBoxReminder(self);
    },
    // open dialog
    openDialog (isEdit) {
      if (isEdit) {
        this.visibleDialogTitle = "编辑部门";
      } else {
        this.visibleDialogTitle = "添加部门";
      }
      this.visibleDialog = true;
    },
    handleClickDeleteSelfMessageBoxReminder (self) {
      this.$confirm(
        `
					<h5>是否删除该部门及下级部门</h5>
					<p style="color:#F56C6C">
						当部门或下级部门有成员时将不能删除,
						<span style="color:#666666">您还要继续吗?</span>
					</p>
				`,
        "",
        {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          let params = {};
          params.corpGroupId = self.corpGroupId;
          ApiCorpMethods.OrganizationController.delGroup(params)
            .then(res => {
              if (res.code === "0") {
                setTimeout(() => {
                  this.handleClickDeleteSelfMessageBoxSuccess();
                  this.initTreeGroup();
                }, 300);
              } else {
                setTimeout(() => {
                  this.handleClickDeleteSelfMessageBoxError();
                }, 300);
              }
            })
            .catch(error => {
              this.$message.error(error.description);
            });
        })
        .catch(() => { });
    },
    handleClickDeleteSelfMessageBoxError () {
      this.$confirm(
        `
					<h5>删除失败</h5>
					<p style="color:#666666">该部门或下级部门下有成员，不能删除</p>
				`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "error",
          showCancelButton: false
        }
      );
    },
    handleClickDeleteSelfMessageBoxSuccess () {
      this.$confirm(
        `
					<h5>删除成功</h5>
					<p style="color:#666666"></p>
				`,
        "",
        {
          confirmButtonText: "确定",
          showClose: false,
          dangerouslyUseHTMLString: true,
          type: "success",
          showCancelButton: false
        }
      );
    },
    // handle add dept and edit dept
    handleClickAddEdit () {
      this.$refs.formDept.validate(valid => {
        if (valid) {
          this.visibleDialog = false;
          let params = {};
          params.corpGroupId = this.modelDialog.departmentId;
          params.corpParentGroupId = this.modelDialog.parentId;
          params.groupName = this.modelDialog.departmentName;
          ApiCorpMethods.OrganizationController.updateGroup(params)
            .then(res => {
              if (res.code === "0") {
                const tip = params.corpGroupId ? "编辑" : "添加";
                this.$message.success(`${tip}[${params.groupName}]成功`);
                this.initTreeGroup();
              } else {
                this.$message.error(res.description);
                this.errorDescription = res.description;
              }
            })
            .catch(error => {
              this.$message.error(error.description);
            });
        } else {
          return false;
        }
      });
    },

    handleCheck (node, all) {
      if (node.corpGroupId !== this.selectNodeDeptId) {
        if (all.checkedKeys.length > 0) {
          this.selectNodeDeptId = node.corpGroupId;
          this.$refs.tree.setCheckedKeys([node.corpGroupId]);
        }
      } else {
        this.$refs.tree.setChecked(node, true);
      }
      this.modelDialog.parentId = node.corpGroupId;
    },

    // 编辑获取上级部门(上级部门的兄弟以及顶级部门)
    getSuperDepartment (self) {
      for (let index = 0; index < this.treeGroup.length; index++) {
        this.superDepts = {};
        this.superDepts = JSON.parse(JSON.stringify(this.treeGroup[index]));

        if (this.superDepts.childCorpGroups) {
          for (
            let index = 0;
            index < this.superDepts.childCorpGroups.length;
            index++
          ) {
            const element = this.superDepts.childCorpGroups[index];
            if (self.corpGroupId === element.corpGroupId) {
              element.disabled = true;
              element.d;
              if (element.childCorpGroups) {
                this.recursionSetChildDisabled(element.childCorpGroups);
              }
              break;
            }
            if (element.childCorpGroups) {
              this.recursionGetSuperDepts(self, element.childCorpGroups);
            }
          }
        }
      }
      this.superDeptsTree = [JSON.parse(JSON.stringify(this.superDepts))];
      this.superDeptsTreeCopy = [JSON.parse(JSON.stringify(this.superDepts))];
    },
    recursionGetSuperDepts (self, childCorpGroups) {
      for (let index = 0; index < childCorpGroups.length; index++) {
        const element = childCorpGroups[index];
        if (self.corpGroupId === element.corpGroupId) {
          element.disabled = true;
          if (element.childCorpGroups) {
            this.recursionSetChildDisabled(element.childCorpGroups);
          }
          break;
        }
        if (element.childCorpGroups) {
          this.recursionGetSuperDepts(self, element.childCorpGroups);
        }
      }
    },
    recursionSetChildDisabled (childCorpGroups) {
      for (let index = 0; index < childCorpGroups.length; index++) {
        const element = childCorpGroups[index];
        element.disabled = true;
        if (element.childCorpGroups) {
          this.recursionSetChildDisabled(element.childCorpGroups);
        }
      }
    },

    // pagination event
    // 分页事件
    handleSizeChange (val) {
      this.setManagerFilters.itemPage = 1;
      this.setManagerFilters.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.setManagerFilters.itemPage = val;
      this.queryTool();
    },
    // table related events
    // query member table data
    queryTool () {
      this.selectCorpUserId = undefined;
      this.setManagerFilters.targetId = this.setManagerFilters.keyword;
      // this.setManagerFilters.corpGroupId = this.selectCorpGroupId;
      ApiCorpMethods.OrganizationController.listCorpUsers(
        this.setManagerFilters
      )
        .then(res => {
          if (res.code === "0") {
            this.tableSetManager = res.data;
            this.setManagerFilters.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    reset () {
      this.setManagerFilters = {
        keyword: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      };
      this.handleClickSearchManager();
    },
    handleClickSearchManager () {
      this.queryTool();
    },
    handleClickRow (row) {
      if(row.identityAuth !==1) return this.$message.warning('当前成员未实名，不能设置为部门主管')
      this.selectCorpUserId = row.corpUserId;
    }
  },
  computed: {
    saasDeft () {
      const outline = this.treeGroup[0]
      return outline && outline.childCorpGroups ? outline.childCorpGroups : []
    },
    isAdmin () {
      if (isInDingTalk) {
        const { sys } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
        return isInDingTalk && sys
      } else {
        return false
      }
    }
  }
};
</script>
<style>
.custom-btn strong {
  margin: 0 5px;
  color: red;
  vertical-align: text-bottom;
}
.custom-btn > a {
  color: #290202;
  font-weight: bold;
}
.custom-btn > a:hover {
  color: #ec1c1c;
  text-decoration: none;
}
.expand-icon-style {
  display: inline-block;
  width: 22px;
  color: red;
  margin-right: 5px;
  cursor: pointer;
}
.expand-icon-style i {
  font-size: 18px;
  vertical-align: middle;
  margin-top: -2px;
}
</style>

<style scoped lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.title-lab {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
.dia-sync-sty {
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    width: 45%;
    padding: 20px;
    box-shadow: 0px 0px 4px 0px #d1cdcd;
    &:first-child {
      margin-right: 10px;
    }
    .tree-sty {
      height: 30vh;
      margin-bottom: 20px;
      overflow: auto;
    }
  }
}
.table-style {
  background: #ffffff;
}
.table-style table {
  border-bottom: 0;
}
.table-style table thead tr th,
.table-style table thead tr td {
  border-bottom: 1px solid #ebeef5;
  line-height: 45px;
}
.custom-btn strong {
  margin: 0 5px;
  color: red;
  vertical-align: text-bottom;
}
.custom-btn > a {
  color: #290202;
  font-weight: bold;
}
.custom-btn > a:hover {
  color: #ec1c1c;
  text-decoration: none;
}
.expand-icon-style {
  color: red;
  margin-right: 5px;
  cursor: pointer;
}
.expand-icon-style i {
  font-size: 18px;
  vertical-align: middle;
  margin-top: -2px;
}
.custom-table-style .el-table__body tr.current-row > td {
  background-color: #fda2a2;
}
</style>



// WEBPACK FOOTER //
// pages/console/organization.vue